import React from 'react'

import { B2BQrsTable, B2BQrsActions } from './components'

export const B2BQrsPage = (): React.ReactElement => {
  return (
    <>
      <B2BQrsActions />
      <B2BQrsTable />
    </>
  )
}
